module.exports = __webpack_public_path__ + "img/banner1.6516be5a.png";